module.exports = __webpack_public_path__ + "img/sort_down.425a296f.svg";